import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://admin.1oneplus.net/api';

const getAuthToken = () => {
    const token = localStorage.getItem("token");
    if (token) return token;

    const user = JSON.parse(localStorage.getItem("userTools"));
    return user?.token;
};

const createAuthHeader = () => {
    const token = getAuthToken();
    const sessionId = sessionStorage.getItem('sessionId');
    const headers = {};
    if (token && token !== 'social_login_placeholder') {
        headers.Authorization = `Bearer ${token}`;
    }
    if (sessionId && sessionId !== 'null' && sessionId !== 'undefined') {
        headers['X-Session-Id'] = sessionId;
    }
    return headers;
};

// Fetch Favorites
export const fetchFavorites = createAsyncThunk(
    "favorite/fetchFavorites",
    async ({ language, page = 1 }, { rejectWithValue }) => {
        try {
            const token = getAuthToken();
            if (token === 'social_login_placeholder') {
                // Return empty list or specific error that UI handles gracefully
                // For fetch, maybe just return empty data?
                // But UI expects { data: [] } structure roughly.
                // Let's return a "silent" error or empty structure.
                return { data: [], meta: {} };
            }

            const headers = {
                ...createAuthHeader(),
                'Accept-Language': language || 'en'
            };
            const response = await axios.get(`${BASE_URL}/favorites?page=${page}`, { headers });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Error fetching favorites" });
        }
    }
);

// Toggle Favorite
export const toggleFavorite = createAsyncThunk(
    "favorite/toggleFavorite",
    async ({ productId, language }, { rejectWithValue }) => {
        try {
            const token = getAuthToken();
            if (token === 'social_login_placeholder') {
                return rejectWithValue({ message: "You must be logged in to add favorites." });
            }

            const headers = {
                ...createAuthHeader(),
                'Accept-Language': language || 'en'
            };
            const response = await axios.post(`${BASE_URL}/favorites/toggle/${productId}`, {}, { headers });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Error toggling favorite" });
        }
    }
);
